<template>
    <div class="home-public">

        <div class="login-button-wrapper">
            <b-btn size="sm" variant="primary"
                   @click.stop="showModal()">
                {{ $i18n.gt('LABEL_LOGIN') }}
            </b-btn>
        </div>

        <b-carousel fade
                    :interval="25000"
                    class="home-slideshow">
            <b-carousel-slide img-src="/../../images/health-coach-patient-2.jpg">
            </b-carousel-slide>
            <b-carousel-slide img-src="/../../images/health-coach-video-chat.jpg">
            </b-carousel-slide>
            <b-carousel-slide img-src="/../../images/health-coach-patient.jpg">
            </b-carousel-slide>
        </b-carousel>

        <div class="user-login-form-wrapper mt-5 mt-sm-5">
            <h1>{{ $i18n.gt('HOME_INTRO_TITLE') }}</h1>
            <div class="home-intro-link-wrapper">
                <div class="home-intro-link" v-html="$i18n.gt('HOME_INTRO_LINK')"></div>
            </div>
            <div class="home-intro-wrapper">
                <div class="home-intro" v-html="$i18n.gt('HOME_INTRO')"></div>
                <div class="home-intro-2" v-html="$i18n.gt('HOME_INTRO_2')"></div>
            </div>
        </div>

        <!-- login modal -->
        <b-modal id="login-modal"
                 no-close-on-backdrop
                 body-class="light-bg">

            <template #modal-title>
                <h5>{{ $i18n.gt('LABEL_LOGIN') }}</h5>
            </template>

            <user-login-form :requested-path="requestedPath">
            </user-login-form>

            <template #modal-footer>
                {{ $i18n.gt('LABEL_SET_PASSWORD_PROMPT') }}
                <b-btn size="sm" class="ml-3" to="/user/reset">
                    {{ $i18n.gt('LABEL_FORGOT_PASSWORD') }}
                </b-btn>
            </template>
        </b-modal>

    </div>

</template>

<script>

import Vue from 'vue'

/**
 * Home page for non-logged-in users
 */
export default Vue.extend({
    name: "HomePublic",
    computed: {
        // this is supplied by the Vue http interceptor, see main.js
        requestedPath() {
            return this.$route.params.requestedPath
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show('login-modal')
        },
        // cancel() {
        //     this.$bvModal.hide(`modal_${this.field}`)
        //     this.path[this.field] = this.originalValue
        // },
        // ok() {
        //     this.$bvModal.hide(`modal_${this.field}`)
        //     this.$store.dispatch('savePatientParticipant')
        // },
    }
})

</script>

<style lang="scss">

// REMOVE THESE WHEN VARIABLES AND MIXINS ARE BACK IN
@import '../../sass/base';

.get-started {
    margin: 0 auto;
    max-width: 500px;

    form {
        max-width: 300px;
    }
}

.user-login-form-wrapper {
    color: #fff;
    position: relative;
    z-index: 100;
    background-color: var(--blue);
    margin: 0 auto;
    padding: 2em;
    @include box-shadow(0 0 30px rgba(0, 0, 0, .2));
    // @include absolute-center;
    max-width: 500px;
    min-width: 300px;
    width:100%;

    @media(min-width: 992px) {
        width:100%;
        max-width:1000px;
        h1 {
            text-align: center;
        }
        p {
            font-size: 21px;
            text-align: justify;
        }
    }

    input {
        border: none !important;
    }

    a {
        color: #fff;
    }

    legend {
        text-align: right;
    }

    .btn-primary {
        background-color: var(--base-color) !important;
        border: solid 1px rgba(255, 255, 255, .5) !important;
        opacity: 1 !important;
        color: #fff;
    }

    p {
      margin-top: 1.5em;
    }

    @media (min-width: 1024px) {
        background-color: var(--base-color-transparent-bg-75);
    }
}

.forgot-password {
    text-align: right;

    a {
        display: inline-block;
        position: relative;

        &:after {
            content: "";
            position: absolute;
            top: 100%;
            right: 0;
            display: inline-block;
            width: 100%;
            max-width: 0;
            height: 1px;
            //background-color: #fff;
            transition: all .2s;
        }
    }

    a:hover {
        color: #fff;
        text-decoration: none;

        &:after {
            max-width: 100%;
        }

    }
}

.home-public {
    //width: calc(100% + 15px);
    //
    height: 100%;
    //overflow: hidden;
    //
    //
    //top: 0;
    //transform:translate(-15px, -16px);
    @media (min-width: 1024px) {
        position: absolute !important;
        top: 0;
        left: 0;
        width:100%;
        overflow: hidden;
        max-height:84vh;
    }
}
.home-slideshow {
    display:none;
    z-index: 1;
    width: 100%;
    height: 100vh;
    position: absolute!important;
    @media (max-width: 767px) {
        img {
            width: auto !important;
            max-width: 280% !important;
            height: 80vh !important;
            min-height: 80vh !important;
        }
    }
    @media (min-width:768px) {
        img {
            /*width: auto !important;
            max-width: 280% !important;
            height: 86vh !important;
            min-height: 86vh !important;*/
        }
    }

    @media (min-width:1024px) {
        display:block;
        left:0;
        top:0;
    }

}

.intro-button-wrapper {
    text-align: center;
}
.login-button-wrapper {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 1000;
}

.home-intro-link a {
    font-weight: bold;
    font-size: 14px;
    border:solid 2px #fff;
    padding:.5em 2em;
    margin-top:1em;
    display: inline-block;
}

.home-intro-link a:hover {
    color:#fff!important;
    opacity:.8;
    text-decoration: none;
}

.home-intro-link-wrapper {
    text-align: center;
}

@media (min-width: 1024px) {
    .home-intro-wrapper {
        display:flex;
        justify-content: space-between;
    }

    .home-intro-wrapper > div {
        width:48%;
    }
}

</style>
